module.exports = __webpack_public_path__ + "img/salesgearFullLogo.584f7268.png";